import { Box, Typography } from '@wishket/design-system';

import { twJoin } from 'tailwind-merge';

import { PATH } from '@/shared/constants';
import { Image } from '@/shared/Components';

const FortuneTitle = () => {
  return (
    <Box className="flex items-center gap-1">
      <Typography
        variant="body1"
        className={twJoin(
          'font-bold text-w-gray-900',
          'desktop:typo-subTitle2'
        )}
      >
        오늘의 운세
      </Typography>
      <Image
        src={`${PATH.MEDIA_YOZM_IMAGE}/fortune_crystal_ball.gif`}
        width={24}
        height={24}
        className="size-6"
        alt="운세수정구"
        unoptimized
      />
    </Box>
  );
};

export default FortuneTitle;
